module.exports = __webpack_public_path__ + "img/presention-chart.9228f30d.svg";